import Image from '@tiptap/extension-image'

export const MAMImage = Image.extend({
  addStorage(this: any) {
    return {
      ...(this.parent?.() ?? {}),
      __isImperiaImage: true,
    }
  },
  addAttributes(this: any) {
    // Return an object with attribute configuration
    return {
      ...(this.parent?.() ?? {}),
      width: {
        default: null
      },
      height: {
        default: null
      },
      class: {
        default: null
      },
      id: {
        default: null
      },
      title: {
        default: null
      },
      longdesc: {
        default: null
      },
      style: {
        default: null
      },
      'data-node-id': {
        default: null
      }
    }
  },
  addInputRules() {
    return []
  }
})

// document.getElementById('oi_src').value="33.webp"
// document.getElementById('oi_src').dispatchEvent(new Event('input'), document.getElementById('oi_src').value)
